var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 10.2H6c-2.4 0-4.4 2-4.4 4.4v8.6h5.8V29h17.2v-5.8h5.8v-8.6c0-2.4-2-4.4-4.4-4.4M21.8 26H10.2v-7.2h11.6zM26 16c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.4.6 1.4 1.4c.2.8-.6 1.4-1.4 1.4M24.6 3H7.4v5.8h17.2z"
  })));
};
export default SvgPrint;